'use client';
import React, { useCallback, useEffect } from 'react';
import { isMobile } from '@benzinga/device-utils';
import { disableFreestarStickyFooter } from '@benzinga/ads-utils';

import { OptimizelyPaywall } from '../../components/AuthIterations/SophiIteration/OptimizelyPaywall';
import type { AuthContainerV2Props } from '../types';
import { useAuthTracking } from '../hooks/useAuthTracking';
import { emitPaywallUnlocked } from '../utils/emitPaywallUnlocked';

export const PaywallSurface: React.FC<AuthContainerV2Props> = ({ placement }) => {
  useAuthTracking({ surface: 'paywall' });

  useEffect(() => {
    disableFreestarStickyFooter();
  }, []);

  const handleEdgeUnlock = useCallback(
    (show: boolean) => {
      if (show) return;
      emitPaywallUnlocked({ placement, source: 'edge-checkout' });
    },
    [placement],
  );

  return (
    <OptimizelyPaywall authMode="login" isMobile={isMobile()} placement={placement} setShowPaywall={handleEdgeUnlock} />
  );
};

PaywallSurface.displayName = 'PaywallSurface';
